import { useState, useEffect } from 'react';

/**
 * Animates a numeric value from 0 to `target` over `duration` ms
 * using a cubic ease-out curve. Re-animates whenever `target` changes.
 *
 * Usage:
 *   const displayValue = useAnimatedValue(42000, 1200);
 */
const useAnimatedValue = (target, duration = 1200) => {
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!target) { setDisplay(0); return; }
    let start = null;
    const step = (ts) => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / duration, 1);
      setDisplay(Math.floor(target * (1 - Math.pow(1 - p, 3))));
      if (p < 1) requestAnimationFrame(step);
    };
    const raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);

  return display;
};

export default useAnimatedValue;
